import React, { useState } from 'react';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ExamType } from '../../../../../api/types/settings/studies/exam-type';
import dateUtils from '../../../../../utils/date-format';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { AddNewExamTypeDialog } from './componenets/add-new-exam-type-dialog';
import { deleteExamOperation } from './operations/delete-exam-operation';
import { EditTextDialog } from '../../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../../operations/update-entity-name/settings-entity-types';
import { observer } from 'mobx-react-lite';

export const SettingsEducationExamsTab = observer(() => {
  const [addNewExamType, setAddNewExamType] = useState(false);
  const [editExam, setEditExam] = useState<ExamType | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedExams, setSelectedExams] = useState<ExamType[]>([]);

  const [deleteExamId, setDeleteExamId] = useState<number | null>(null);

  const handleDeleteExam = async (examId: number) => {
    await deleteExamOperation(examId, setDeleteExamId);
  };

  const handleEditExam = (exam: ExamType) => {
    setEditExam(exam);
  };

  const handleSaveExam = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.EXAM_TYPE,
      id,
      newName,
      setLoading,
    );
  };

  return (
    <div>
      <Dialog
        header="הוספת סוג מבחן"
        visible={addNewExamType}
        onHide={() => setAddNewExamType(false)}
        style={{
          width: '500px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
      >
        <AddNewExamTypeDialog onHide={() => setAddNewExamType(false)} />
      </Dialog>

      <EditTextDialog
        id={editExam?.id}
        value={editExam?.examTypeName}
        title="עריכת סוג מבחן"
        label="שם סוג המבחן"
        loading={loading}
        onSave={handleSaveExam}
        onHide={() => setEditExam(null)}
      />

      <Button
        onClick={() => setAddNewExamType(true)}
        style={{ height: '30px' }}
        label={'הוספה'}
      />
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode="multiple"
        selection={selectedExams}
        onSelectionChange={(e) => setSelectedExams(e.value)}
        value={globalSettingsStores.examTypes}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column
          style={{ textAlign: 'right' }}
          field="examTypeName"
          header="שם"
        />

        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״"
        />

        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="נוצר בתאריך"
          body={(rowData: ExamType) => (
            <div>{dateUtils.displayFormatDate(rowData.createdAt)}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: ExamType) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת סוג מבחן'}
                onClick={() => handleEditExam(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת סוג מבחן'}
                loading={deleteExamId === data.id}
                disabled={deleteExamId !== null}
                onClick={() => handleDeleteExam(data.id)}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
});
